// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"BulletList-primaryButton-213wwb","bulletItem":"BulletList-bulletItem-YyhID8","bullet":"BulletList-bullet-Ukycg-","bulletText":"BulletList-bulletText-14VI3U"};